<template>
    <div style="background-color: white">
       <div class="branch" v-if="!visible">
           <h2 class="city_title">点击城市查询详细信息</h2>
           <van-row style="height: calc(100% - 1.4rem ); overflow: auto">
               <van-col class="city" span="6" v-for="(item,index) in data"
                        :key="index"
                        :style="[{color:clickIndex===index?'red':'#000'}]">
                   <div @click="handleOrganList(item,index)">{{item.groupName}}</div>
               </van-col>
           </van-row>
       </div>

        <grouping-organ-list :visible="visible" :groupData="groupData" @update:visible="visible=false"></grouping-organ-list>
    </div>
</template>

<script>
    export default {
        name: "branch",
        components: {
            GroupingOrganList: () => import('./Grouping_organList.vue')
        },
        data() {
            return {
                data: [],
                groupData: {},
                visible: false,
                clickIndex: "",
            }
        },
        mounted() {
            this.$axios.post('/site/information/listSiteGroup', {params: {logisticsCompanyId:this.$logisticsCompanyId}}).then(res => {
                this.data = res.data.data
            })
        },
        methods: {
            handleOrganList(item, index) {
                this.clickIndex = index
                this.groupData = item
                this.visible = true
            },
        }

    }
</script>

<style scoped lang="scss">
    .branch {
        background-color: #fff;

        .city_title {
            font-size: .6rem;
            line-height: 1rem;
            padding: .2rem 0 .2rem .5rem;
            font-weight: bold;
        }

        .city {
            text-align: center;
            font-size: .5rem;
            line-height: 1.2rem;
        }

    }

</style>